import React from 'react';
import ListContainer from './styles';
import { icons } from '../../../../../utils';
import { useTranslation } from 'react-i18next';
import Information from '../../../../../components/Cards/Information';

const SocialNetworks = () => {
	const { t } = useTranslation();

	const getItems = () => {
		return icons.map((item, idx) => (
			<Information
				key={idx}
				title={t(item.title)}
				description={t(item.description)}
				detail={t(item.detail)}
				icon={item.image}
			/>
		));
	};

	return <ListContainer>{getItems()}</ListContainer>;
};

export default SocialNetworks;
